import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useRouteMatch, useHistory } from 'react-router-dom';
import { get, find } from 'lodash';
import i18n from 'i18n';
import apiCubic from 'config/api-cubic';
import api from 'config/api';
import requester from 'utils/requester';
import { getAuthorizedEndpointUrl } from 'helpers/urlhelper';
import { buyDetailsItem } from 'actions/details';
import getLocalized from 'utils/get-localized';
import useModals from './useModals';
import { hideLoader, showLoader } from 'actions/loader';
import { showToast } from 'actions/toast';
import { backToPageThatCausedAuth } from 'actions/app';

const useBuyDetailsTariff = (VodId) => {
  const history = useHistory();
  const match = useRouteMatch();
  const dispatch = useDispatch();
  const { showPortmonePaymentModal } = useModals();

  const buyActions = useCallback(
    async ({ tariffId, contractCode }) => {
      if (typeof tariffId === 'string') tariffId = Number(tariffId);

      let item = null;
      let cost = null;
      let title = '';
      let purchaseData = null;

      try {
        dispatch(showLoader());

        const endpoint = getAuthorizedEndpointUrl(api.endpoints.details, true);
        const vodData = await requester({
          method: 'get',
          url: `${api.host}${endpoint}asset/${VodId}`,
          params: {
            vf: 'dash',
            detailed: true,
          },
        });

        if (vodData?.visibilityRights === 'PLAY') {
          dispatch(backToPageThatCausedAuth());
          // to actually item page
          setTimeout(() => history.go(-1), 100);
          dispatch(showToast({ options: { toastText: i18n.t('common.toast.successAuth') } }));
          return;
        }

        item = find(vodData.prices, { id: tariffId });

        // https://hootko.atlassian.net/browse/STVWL-525
        const { data: priceData } = await apiCubic.post({
          endpoint: apiCubic.endpoints.getSubForTVOD,
          data: {
            tsuCode: item.ref,
            contractCode,
          },
        });

        title = getLocalized(vodData?.titles, get(vodData, 'titles.UA.title', vodData?.title));
        cost = priceData.payload.moneyToPay;

        purchaseData = {
          assetId: vodData.id,
          assetName: vodData.name,
          tsuCode: item.ref,
          assetType: get(vodData.metadata, ['contentType'], 'TV_SERIES'),
          typeTVOD: vodData.duration ? 'TVOD' : 'EST',
          matchParams: match.params,
        };
      } finally {
        dispatch(hideLoader());
      }

      const repeatIfError = () => buyActions({ tariffId, contractCode });

      if (cost > 0) {
        const dueDate = item.duration ? i18n.t('detailsTariffs.duration', { count: item.duration }) : null;

        showPortmonePaymentModal(
          {
            title,
            cost,
            isTVOD: true,
            dueDate,
            contractCode,
            onSuccess: () => dispatch(buyDetailsItem(purchaseData, repeatIfError)),
          },
          { sectionToFocus: '@DETAILS_TARIFFS' },
        );
        return;
      }

      dispatch(buyDetailsItem(purchaseData, repeatIfError));
    },
    [VodId, dispatch, history, match.params, showPortmonePaymentModal],
  );

  return buyActions;
};

export default useBuyDetailsTariff;
